export const FETCH_SIFT = 'views/users/FETCH_SIFT'
export const FETCH_CIRCUIT = 'views/users/FETCH_CIRCUIT'

